import { render, staticRenderFns } from "./ProductFieldPageChange.vue?vue&type=template&id=2f9ec0d4&"
import script from "./ProductFieldPageChange.vue?vue&type=script&lang=js&"
export * from "./ProductFieldPageChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports